module.exports = __webpack_public_path__ + "static/media/20ECE4.fa0e5825.jpg";